import { Container } from "@mui/material";
import Head from "../components/head/Head";
import Grid from "@mui/material/Unstable_Grid2";

function Debug() {
  return (
    <>
      <Head title={"DEBUG"} />
      <Container maxWidth="lg">
        <Grid
          sx={{ height: "100vh", paddingBottom: "100px" }}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            DEBUG
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Debug;
